import React from "preact/compat";
import { withCatalogLayout } from "@/elements-react/catalog-layout/withCatalogLayout";
import { LayoutStyleTypes } from "@/util-react/layout";
import { BrandsPageCommon } from "./BrandsPageCommon";

export const BrandsPageMobile: React.FC = withCatalogLayout(() => {
  return <BrandsPageCommon type={LayoutStyleTypes.TYPE_SM} />;
}, LayoutStyleTypes.TYPE_SM);
